<template>
	<div class="portal-ad">
		<el-header class="userQueryHeader" height="32px">
			<div class="userQueryHeader-wrap"><span>查询用户列表</span></div>
		</el-header>
		<el-header height="auto" style="height: auto; padding: 16px 20px;">
			<div class="sw-fliter search-fliter">
				<el-row class="is-justify-space-between el-row--flex">
					<el-col :span="6" :offset="18">
						<!-- <sw-fliter
							:normalSearchName="'accountAndUserName'"
							:searchQuery="searchQuery"
							@search="searchHandle"
							@normalSearch="normalSearchHandle"
							:placeholder="'输入账号进行查询'"
						>
						</sw-fliter> -->
						<sw-search :placeholder="'请输入工号查询'" @search="searchHandle"></sw-search>
					</el-col>
				</el-row>
			</div>
		</el-header>
		<el-main style="padding-top: 0px; box-sizing: border-box;">
			<div class="table-wrap">
				<sw-table
					:tableName="'sw-table-example-4'"
					:tableData="tableData"
					:tableTitle="tableTitle"
					:tableOperation="tableOperation1"
					@operation-handle="operationHandle"
					:showIndex="true"
					max-height="500"
					row-key="index"
					pagination
					:totalCount="totalCount"
					:pageIndex="pageIndex"
					:pageSize="pageSize"
					@prev-page="pervPage"
					@next-page="nextPage"
					@change-page="changePage"
				></sw-table>
			</div>
		</el-main>
	<el-dialog
	title="提示"
	:visible.sync="dialogVisible"
	width="30%"
	:before-close="handleClose">
		<el-form ref="form" :rules="rules" :model="form" label-width="80px">
			<el-form-item label="原手机号" prop="yuanshouji">
				<el-input v-model="form.yuanshouji" :disabled="true"></el-input>
			</el-form-item>
			<el-form-item label="新手机号" prop="xinshouji">
				<el-input v-model="form.xinshouji"></el-input>
			</el-form-item>
		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button @click="cancle">取 消</el-button>
			<el-button type="primary" @click="xgsj">确 定</el-button>
		</span>
	</el-dialog>
	<el-dialog
	title="提示"
	:visible.sync="dialogVisible2"
	width="30%"
	:before-close="handleClose">
		<el-form ref="form" :rules="rules" :model="form" label-width="80px">
			<el-form-item label="绑定手机号" prop="xinshouji">
				<el-input v-model="newePhone"></el-input>
			</el-form-item>
		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button @click="cancle">取 消</el-button>
			<el-button type="primary" @click="bdsj">确 定</el-button>
		</span>
	</el-dialog>

	</div>
</template>
<script>
import { getUserList, findSecurityPhone, updateSecurithPhone } from "@/api/userQuery";
export default {
	name: 'admin',
	components: {},
	data() {
		return {
			form:{
				yuanshouji: '',
				xinshouji: ''
			},
			newePhone: '',
			userId: '',
			rules: {
				yuanshouji: [
					{required: true, message: '请输入原手机号码', trigger: 'blur'},
					{
						pattern: /^1(3|4|5|7|8|9)\d{9}$/,
						message: '手机号码格式不正确'
					}
				],
				xinshouji: [
					{required: true, message: '请输入新手机号码', trigger: 'blur'},
					{
						pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
						message: '手机号码格式不正确'
					}
				],
				newePhone: [
					{required: true, message: '请输入新手机号码', trigger: 'blur'},
					{
						pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
						message: '手机号码格式不正确'
					}
				]
			},
			dialogVisible: false,
			dialogVisible2: false,
			activeIndex: '1',
			// searchQuery: {
			// 	accountAndUserName: { value: '', placeholder: '根据账号和用户姓名查询', type: 'input', width: '192' },
			// },
			tableData: [],
			tableTitle: [
				{ prop: 'accountName', label: '账户名称', width: '120', sortable: true },
				{ prop: 'userName', label: '姓名', width: '120', sortable: true },
				{ prop: 'identityTypeName', label: '身份', width: '120', sortable: true },
				{ prop: 'organizationName', label: '组织机构', width: '120', sortable: true },
				{ prop: 'state', label: '状态', width: '120', sortable: true },
			],
			tableOperation1: [
				// { name: '详情', icon: 'su-icon-details', operation: 'detail' },
				{ name: '编辑', icon: 'su-icon-edit', operation: 'edit', className: 'testgreen' },
				// { name: '删除', icon: 'su-icon-delete', operation: 'delete' },
				// { name: '冻结', operation: 'freeze' }
			],
			detailList:[],
			shouji: '152523655',
			totalCount: '',
			pageIndex: 1,
			pageSize: [10],
			key: ''
		};
	},
	watch: {
	
	},
	mounted() {
		this.handUserList();
	},
	methods: {
		handUserList(){
			let data = {
				key : this.key,
				pageIndex: this.pageIndex - 1,
				pageSize: this.pageSize
			};
			getUserList(data).then((res) => {
				this.tableData = res.data.items;
				this.totalCount = res.data.totalCount;
			})
		},
		searchHandle(val) {
			this.key = val;
			this.pageIndex = 1;
			this.handUserList();
		},
		searchInputHandle() {
			this.$alert(this.searchQuery.accountAndUserName.value);
		},
		normalSearchHandle(val) {
			this.$alert(val);
		},
		operationHandle(id, operation, row) {
			//this._data[`${operation}VisibleTable`]=!this._data[`${operation}VisibleTable`];//当需要弹窗时可以使用这行代码
			// this.$confirm(id + ',' + operation);
			if (this[`${operation}Handle`]) {
				this[`${operation}Handle`](id, operation, row);
			}
		},
		// detailHandle() {
		// 	this.$confirm('我是detail的回调函数');
		// },
		editHandle(id, operation, row){
			console.log(row.userId);
			this.userId = row.userId;
			let data = {
				userId : row.userId
			};
			findSecurityPhone(data).then((res) => {
				if(res.data.phone == null){
					this.dialogVisible2 = true;
				}else{
					this.form.yuanshouji = res.data.phone;
					this.dialogVisible = true;
				}
			})
			
			
			// this.$confirm('我是detail的回调函数');
			// this.$prompt('请输入新手机号', '提示', {
			// 	confirmButtonText: '确定',
			// 	cancelButtonText: '取消',
			// 	inputPattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
			// 	inputErrorMessage: '手机格式不正确'
			// }).then(({value}) => {
			// 	this.$message({
			// 		type: 'success',
			// 		message: '您的新手机号是：' + value
			// 	});
			// }).catch(() => {
			// 	this.$message({
			// 		type: 'info',
			// 		message: '取消输入'
			// 	})
			// })
			

		},
		bdsj(){
			let data = {
				phoneNumber: this.newePhone,
				userId: this.userId
			};
			updateSecurithPhone(data).then((res) => {
				if(res.data.status == 200){
					this.$message({
						type: "success",
						message: res.data.message
					})
				}else{
					this.$message({
						type: "error",
						message: res.data.message
					})
				}
			})
			this.newePhone = '';
			this.dialogVisible2 = false;
		},
		xgsj(){
			let data = {
				phoneNumber: this.form.xinshouji,
				userId: this.userId
			}
			updateSecurithPhone(data).then((res) => {
				if(res.data.status == 200){
					this.$message({
						type: "success",
						message: res.data.message
					})
				}else{
					this.$message({
						type: "error",
						message: res.data.message
					})
				}
			});
			this.form.yuanshouji = '';
			this.form.xinshouji = '';
			this.dialogVisible = false;
		},
		cancle(){
			this.form.yuanshouji = '';
			this.form.xinshouji = '';
			this.dialogVisible = false;
		},
		handleClose(done) {
			this.$confirm('确认关闭？')
			.then(_ => {
				done();
			})
			.catch(_ => {});
		},
		changePage(e){
			this.pageIndex = e;
			this.handUserList();
		},
		pervPage(e){
			this.pageIndex = e;
			this.handUserList();
		},
		nextPage(e){
			this.pageIndex = e;
			this.handUserList();
		}
		// async getdetailList() {
		// 	let data = await request({
		// 		url: `${this.$config.baseUrl}v1/cms/marqueeList/get?pageIndex=0&itemsPerPage=100&marqueeTypeName=&picSource=`,
		// 		method: 'get',
		// 		headerType: 'portal'
		// 	});
		// 	if (data && data.code === 0 && data.data) {
		// 		// console.log(data.data)
		// 		this.detailList = data.data;
		// 		this.detailList.forEach((item,index) => {
		// 			item.list.forEach((item1) =>{
		// 				// console.log(item1.enableStatus)
		// 				if(item1.enableStatus == 1 ){
		// 					this.detailList[index].enableStatus = item1.enableStatus;
		// 				}
		// 			})
		// 		})
		// 	} else {
		// 		this.$message.error(data.message);
		// 	}
		// },
	}
};
</script>
<style lang="scss">
.portal-ad {
	height: calc(100vh - 100px);
	.userQueryHeader {
		background: #f4f8fc;
		box-shadow: 0px -2px 3px rgba($color: #e7e7e7, $alpha: 0.5) inset;
		span {
			font-size: 12px;
			line-height: 32px;
			padding: 0 2px;
		}
		&-wrap {
			span {
				padding-left: 7px;
				border-left: 3px solid #3394e1;
				color: rgba(2, 21, 37, 0.45);
			}
		}
	}
	.table-wrap{
		padding-top: 0;
		height: calc(100vh - 200px);
		max-height: calc(100vh - 180px);
		overflow-x: hidden;
		overflow-y: auto;
		position: relative;
		margin-top: 16px;
		flex: 1 1 0%;
	}
}
</style>